var image_viewer_default = {
  "fontElementMap": "CWQ4-",
  "imageContainer": "e7ytx",
  "expandButton": "Uz933",
  "expandIcon": "cZKur",
  "pointer": "XA0M-",
  "imageWrapper": "hidTM",
  "imageRatio": "rIYC5",
  "image": "_172l6",
  "imageOverlay": "W7J7e",
  "imagePreload": "olYff",
  "imageHighres": "CC7Gj",
  "onlyHighRes": "-g0vH",
  "image_loading": "mFhA2"
};
export {
  image_viewer_default as default
};
//# sourceMappingURL=image-viewer-scss.js.map
